import { Pipe, PipeTransform } from '@angular/core';

const GAME_TITLES: Record<string, string> = {
  vintagestory: 'Vintage Story',
};

@Pipe({ name: 'gameTitle' })
export class GameTitlePipe implements PipeTransform {
  transform(type: string): string {
    return GAME_TITLES[type] ?? type.replace(/\b\w/g, c => c.toUpperCase());
  }
}
